import { MutableRefObject, useEffect } from 'react';

export const useScroll = (ref: MutableRefObject<HTMLElement>, scrollOffset: number) => {
    useEffect(() => {
        if (ref.current) {
            ref.current.scroll({ top: scrollOffset });
        }
    }, [ref?.current]);
};
